import React, { Component } from 'react'
import {
  Input,
  Form,
  Col,
  Button,
  Table,
  Row,
  message,
  Tooltip,
  Popconfirm,
  Checkbox,
} from 'antd'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import apiRequest from '../hooks/ApiRequest'

class ManageProducts extends Component {
  constructor() {
    super()
    this.state = {
      productList: [],
      productName: '',
      productId: 0,
      minimumPremium: 0,
      sumInsured: 0,
      isCrmProduct: false,
      columns: [
        { key: '1', title: 'Product Name', dataIndex: 'productname' },
        { key: '3', title: 'Minimum Premium', dataIndex: 'minimumPremium' },
        { key: '4', title: 'Sum Insured ($)', dataIndex: 'sumInsured' },
        {
          key: '5',
          title: 'CRM Product',
          dataIndex: 'isCrmProduct'     
        },
        {
          key: '2',
          title: 'Action',
          render: (_, record) => (
            <>
              <Tooltip title="Edit">
                <Button
                  type="primary"
                  className="edit_btn m-r-5"
                  onClick={() => this.handleEditProduct(record)}>
                  <EditOutlined />
                </Button>
              </Tooltip>

              <Popconfirm
                className="delete_btn"
                title="Are you sure you want to delete this record?"
                onConfirm={() => this.handleDeleteProduct(record.productid)}>
                <Tooltip title="Delete">
                  <Button type="danger" style={{ marginLeft: 8 }}>
                    <DeleteOutlined />
                  </Button>
                </Tooltip>
              </Popconfirm>
            </>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.fetchProducts()
  }

  fetchProducts = async () => {
    const response = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
      'GET',
    )
    if (response.success) {
      this.setState({ productList: response.data?.data })
    }
  }

  handleEditProduct = record => {
    this.setState({
      productId: record.productid,
      productName: record.productname,
      minimumPremium: record.minimumPremium,
      sumInsured: record.sumInsured || 0,
      isCrmProduct: record.isCrmProduct || false,
    })
  }

  handleDeleteProduct = async id => {
    const response = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + `/Product/DeleteProductById/${id}`,
      'POST',
    )

    if (response.success) {
      message.success('Product Deleted Successfully!')
      this.fetchProducts()
    }
  }

  handleSubmit = async e => {
    e.preventDefault()
    const { productId, productName, minimumPremium, sumInsured, isCrmProduct } = this.state

    if (!productName.trim()) {
      message.error('Product Name is required!')
      return
    }
    if (minimumPremium === '' || minimumPremium === null || Number(minimumPremium) < 0) {
      message.error('Minimum Premium must be 0 or greater!')
      return
    }
    if (sumInsured === '' || sumInsured === null || Number(sumInsured) < 0) {
      message.error('Sum Insured must be 0 or greater!')
      return
    }

    const requestPayload = {
      productid: productId,
      productName,
      minimumPremium: parseFloat(minimumPremium),
      sumInsured: parseFloat(sumInsured),
      isCrmProduct: isCrmProduct,
      createdby: parseInt(localStorage.getItem('loggedInUserID')),
      modifiedby: parseInt(localStorage.getItem('loggedInUserID')),
      createddate: new Date(),
      modifieddate: new Date(),
      isactive: true,
    }

    const url = productId
      ? `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/UpdateProduct/update`
      : `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/AddProduct/Add`

    try {
      const response = await apiRequest(url, 'POST', requestPayload)
      if (response.success) {
        message.success(
          productId ? 'Product Updated Successfully!' : 'Product Added Successfully!',
        )
        this.setState({
          productName: '',
          minimumPremium: 0,
          sumInsured: 0,
          isCrmProduct: false,
          productId: 0,
        })
        this.fetchProducts()
      } else {
        message.error('Something went wrong!')
      }
    } catch (error) {
      console.error('API Error:', error)
      message.error('Failed to process request!')
    }
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleCheckboxChange = e => {
    this.setState({ isCrmProduct: e.target.checked })
  }

  render() {
    return (
      <div title="Manage Products" className="ant-layout-content dashboard">
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  Manage Products
                </h3>
              </div>
            </Col>
          </Row>
        </div>

        {/* Form for Add/Update Product */}
        <div>
          <Row className="m-t-30 m-b-40">
            <div className="dash-bg-white" style={{ width: '100%' }}>
              <Form onSubmit={this.handleSubmit}>
                <Row gutter={[16, 16]} align="middle">
                  {/* Product Name */}
                  <Col xs={24} md={8} lg={6}>
                    <Form.Item label="Product Name">
                      <Input
                        name="productName"
                        placeholder="Enter Product Name"
                        value={this.state.productName}
                        onChange={this.handleChange}
                      />
                    </Form.Item>
                  </Col>

                  {/* Sum Insured */}
                  <Col xs={24} md={8} lg={6}>
                    <Form.Item label="Sum Insured">
                      <Input
                        type="number"
                        name="sumInsured"
                        placeholder="Enter Sum Insured"
                        value={this.state.sumInsured}
                        onChange={this.handleChange}
                        min={0}
                        step="0.01"
                      />
                    </Form.Item>
                  </Col>

                  {/* Minimum Premium */}
                  <Col xs={24} md={8} lg={6}>
                    <Form.Item label="Minimum Premium">
                      <Input
                        type="number"
                        name="minimumPremium"
                        placeholder="Enter Minimum Premium"
                        value={this.state.minimumPremium}
                        onChange={this.handleChange}
                        min={0}
                        step="0.01"
                      />
                    </Form.Item>
                  </Col>

                  {/* CRM Product Checkbox */}
                  <Col xs={24} md={8} lg={6}>
                    <Form.Item label="CRM Product">
                      <Checkbox
                        checked={this.state.isCrmProduct}
                        onChange={this.handleCheckboxChange}>
                        Is CRM Product
                      </Checkbox>
                    </Form.Item>
                  </Col>

                  {/* Submit Button (Below Fields) */}
                  <Col xs={24} style={{ textAlign: 'left', marginTop: '20px' }}>
                    <Button
                      htmlType="submit"
                      type="primary"
                      style={{ width: '200px' }}>
                      {this.state.productId ? 'Update Product' : 'Add Product'}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>

            {/* Product Table */}
            <div className="table-grid-bx" style={{ marginTop: 20 }}>
              <Table
                className="table-scroll-auto"
                columns={this.state.columns}
                dataSource={this.state.productList}
                pagination={false}
                rowKey="productid"
              />
            </div>
          </Row>
        </div>
      </div>
    )
  }
}

const WrappedManageProducts = Form.create({ name: 'ManageProducts' })(ManageProducts)
export default WrappedManageProducts
